export default __webpack_public_path__ + "fdce43e0f080b8d63b7f2a44e053637a.jpg";